import EpiComponent from '@episerver/spa-core/EpiComponent';
import React, {ReactNode, ReactNodeArray} from 'react';
import GenericVASBlockData from '../../../Models/Content/GenericVASBlockData';
import GenericVAS from './GenericVAS';

export default class GenericVASBlock extends EpiComponent<GenericVASBlockData> {
  constructor(props) {
    super(props);
  }

  public render(): ReactNode | ReactNodeArray | null {
    return <GenericVAS context={this.getContext()} contentData={this.props.data}/>;
  }
}
